import { combineReducers } from 'redux';
import { alertReducer } from './public/alert';
import { blocklistAccessReducer } from './public/blocklistAccess';
import { configsReducer } from './public/configs';
import { currenciesReducer } from './public/currencies';
import { customizationReducer } from './public/customization';
import { errorHandlerReducer } from './public/errorHandler';
import { changeColorThemeReducer } from './public/globalSettings';
import { gridLayoutReducer } from './public/gridLayout';
import { changeLanguageReducer } from './public/i18n';
import { klineReducer } from './public/kline';
import { marketsReducer } from './public/markets';
import { memberLevelsReducer } from './public/memberLevels';
import { depthReducer, incrementDepthReducer, orderBookReducer } from './public/orderBook';
import { rangerReducer } from './public/ranger/reducer';
import { recentTradesReducer } from './public/recentTrades';
import { authReducer } from './user/auth';
import { beneficiariesReducer } from './user/beneficiaries';
import { customizationUpdateReducer } from './user/customization';
import { documentationReducer } from './user/documentation';
import { sendEmailVerificationReducer } from './user/emailVerification';
import { historyReducer } from './user/history';
import { addressesReducer, documentsReducer, identityReducer, labelReducer, phoneReducer } from './user/kyc';
import { openOrdersReducer } from './user/openOrders';
import { ordersReducer } from './user/orders';
import { ordersHistoryReducer } from './user/ordersHistory';
import { passwordReducer } from './user/password';
import { profileReducer } from './user/profile';
// import { accountInfoReducer } from './user/infoAccount';
import { userActivityReducer } from './user/userActivity';
import { walletsReducer } from './user/wallets';
import { withdrawLimitReducer } from './user/withdrawLimit';
import { tickerAllReducer, tickerGroupReducer } from './public/tickers/reducers';
import { chartReducer } from './public/chart/reducers';
import { priceBoardReducer } from './public/price-board/reducers';
import { rankReducer } from './public/rank/reducers';
import { listPriceBoardReducer } from './public/listPriceBoard/reducer';
import { StockOrderBookReducer } from './public/stock-order-book/reducers';
import { StockOpenOrderReducer } from './user/stock-order/reducers';
import { UserAssetsReducer } from './user/assets/reducers';
// import { StockContestBookReducer } from './public/stock-contest-book/reducers';
import { StockOrderHistoryReducer } from './user/stock-order-history/reducers';
import { notificationsReducer } from './user/notifications/reducers';
import { StockNewsReducer } from './public/company/news/reducers';
import { StockEventsReducer } from './public/company/events/reducers';
import { AIanalysisReudcer } from './user/ai_analysis/reducer';
import { contestReducer } from './public/contest/reducers';
import { contestParticipantReducer } from './user/contestParticipant';
import { TrendingTicketReducer } from './public/TrendingTicket';
import { bannerEventReducer } from './public/bannerEvent';
import { contestListReducer } from './public/contestList';

export const publicReducer = combineReducers({
    alerts: alertReducer,
    blocklistAccess: blocklistAccessReducer,
    colorTheme: changeColorThemeReducer,
    configs: configsReducer,
    currencies: currenciesReducer,
    customization: customizationReducer,
    errorHandler: errorHandlerReducer,
    rgl: gridLayoutReducer,
    i18n: changeLanguageReducer,
    kline: klineReducer,
    markets: marketsReducer,
    memberLevels: memberLevelsReducer,
    orderBook: orderBookReducer,
    depth: depthReducer,
    incrementDepth: incrementDepthReducer,
    ranger: rangerReducer,
    recentTrades: recentTradesReducer,
    tickersGroup: tickerGroupReducer,
    tickersAll: tickerAllReducer,
    chart: chartReducer,
    priceBoard: priceBoardReducer,
    rank: rankReducer,
    contest: contestReducer,
    listPriceBoard: listPriceBoardReducer,
    stockOrderBook: StockOrderBookReducer,
    companyNews: StockNewsReducer,
    companyEvents: StockEventsReducer,
    trendingTicket: TrendingTicketReducer,
    bannerEvent: bannerEventReducer,
    contestList: contestListReducer,
});

export const userReducer = combineReducers({
    addresses: addressesReducer,
    auth: authReducer,
    beneficiaries: beneficiariesReducer,
    customizationUpdate: customizationUpdateReducer,
    documentation: documentationReducer,
    history: historyReducer,
    documents: documentsReducer,
    identity: identityReducer,
    label: labelReducer,
    phone: phoneReducer,
    openOrders: openOrdersReducer,
    orders: ordersReducer,
    ordersHistory: ordersHistoryReducer,
    password: passwordReducer,
    profile: profileReducer,
    sendEmailVerification: sendEmailVerificationReducer,
    userActivity: userActivityReducer,
    wallets: walletsReducer,
    withdrawLimit: withdrawLimitReducer,
    stockOpenOrder: StockOpenOrderReducer,
    stockOrderHistory: StockOrderHistoryReducer,
    userAssets: UserAssetsReducer,
    notifications: notificationsReducer,
    aiAnalysis: AIanalysisReudcer,
    contestParticipant: contestParticipantReducer,
});
